var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"s-setting-container no-border"},[_c('PromoTable',{attrs:{"partnerSettings":_vm.partnerSettings,"currentCorporation":_vm.currentCorporation}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }